import useTestTag from '../../common/hooks/use-test-tag';

interface FieldLabelProps {
  label: string;
  name?: string;
  labelStyles?: string;
  /** For controls a `htmlFor` cannot target (e.g. contenteditable editors): focus the control on label click. */
  onClick?: () => void;
}

export default function FieldLabel({ label, name, labelStyles, onClick }: FieldLabelProps) {
  const tagCreator = useTestTag(label || '');

  return (
    <label
      className={labelStyles ?? 'block font-bold text-sm'}
      htmlFor={name}
      onClick={onClick}
      ref={tagCreator('label')}
    >
      {label}
    </label>
  );
}
